import React from "react";
import PagesList from "../pages/CMS/PagesList";
import MenuList from "../pages/CMS/MenuList";
import MediaLibrary from "../pages/CMS/MediaLibrary";

import History from "../pages/AboutCollege/History";
import VisionMission from "../pages/AboutCollege/VisionMission";
import CollegeAtGlance from "../pages/AboutCollege/CollegeAtGlance";
import CollegeKulgeet from "../pages/AboutCollege/CollegeKulgeet";
import AcademicHeritage from "../pages/AboutCollege/AcademicHeritage";
import Chairman from "../pages/AboutCollege/Chairman";
import ViceChairman from "../pages/AboutCollege/ViceChairman";
import Registrar from "../pages/AboutCollege/Registrar";
import ChiefProctor from "../pages/AboutCollege/ChiefProctor";
import FinanceOfficer from "../pages/AboutCollege/FinanceOfficer";
import HeadsOfDepartments from "../pages/AboutCollege/HeadsOfDepartments";
import DeanStudentsWelfare from "../pages/AboutCollege/DeanStudentsWelfare";
import DirectorRankingCell from "../pages/AboutCollege/DirectorRankingCell";
import AdmissionCell from "../pages/AboutCollege/AdmissionCell";
import HostelAdministrators from "../pages/AboutCollege/HostelAdministrators";
import FacultyAdministrators from "../pages/AboutCollege/FacultyAdministrators";
import ProctorialOfficials from "../pages/AboutCollege/ProctorialOfficials";
import CollegeCourt from "../pages/AboutCollege/CollegeCourt";
import ExecutiveCouncil from "../pages/AboutCollege/ExecutiveCouncil";
import AcademicCouncil from "../pages/AboutCollege/AcademicCouncil";
import FinanceCommittee from "../pages/AboutCollege/FinanceCommittee";
import ManageCommittees from "../pages/AboutCollege/ManageCommittees";
import CommitteeMembers from "../pages/AboutCollege/CommitteeMembers";

import AcademicCalendar from "../pages/Academics/AcademicCalendar";
import UGProgrammes from "../pages/Academics/UGProgrammes";
import PGProgrammes from "../pages/Academics/PGProgrammes";

import UGAdmission from "../pages/Academics/UGAdmission";
import PGAdmission from "../pages/Academics/PGAdmission";
import LURNS from "../pages/Academics/LURNS";
import BElEdProgramme from "../pages/Academics/BElEdProgramme";
import OngcCentre from "../pages/Academics/OngcCentre";
import MEdProgramme from "../pages/Academics/MEdProgramme";
import BEdProgramme from "../pages/Academics/BEdProgramme";
import BPEdMPEdProgramme from "../pages/Academics/BPEdMPEdProgramme";
import Syllabus from "../pages/Academics/Syllabus";
import TimeTables from "../pages/Academics/TimeTables";
import DepartmentNotices from "../pages/Academics/DepartmentNotices";
import FacultyMembers from "../pages/Academics/FacultyMembers";
import FacultyDepartment from "../pages/Academics/FacultyDepartment";

import ExaminationNotice from "../pages/Examination/ExaminationNotice";
import ExaminationSchedule from "../pages/Examination/ExaminationSchedule";
import ExaminationLinks from "../pages/Examination/ExaminationLinks";
import Results from "../pages/Examination/Results";

import Canteens from "../pages/Facilities/Canteens";
import ChildCareCentre from "../pages/Facilities/ChildCareCentre";
import Yoga from "../pages/Facilities/Yoga";
import StudentHostels from "../pages/Facilities/StudentHostels";
import PlacementCell from "../pages/Facilities/PlacementCell";
import HappyThinkingLaboratory from "../pages/Facilities/HappyThinkingLaboratory";
import OutdoorSports from "../pages/Facilities/OutdoorSports";
import IndoorSports from "../pages/Facilities/IndoorSports";
import Gymnasium from "../pages/Facilities/Gymnasium";

import UGLibrary from "../pages/Library/UGLibrary";
import PGLibrary from "../pages/Library/PGLibrary";

import Media from "../pages/MediaContact/Media";
import CollegeInNews from "../pages/MediaContact/CollegeInNews";
import PhotoGallery from "../pages/MediaContact/PhotoGallery";
import BannerManagement from "../pages/MediaContact/BannerManagement";
import Videos from "../pages/MediaContact/Videos";
import PressRelease from "../pages/MediaContact/PressRelease";
import Notice from "../pages/MediaContact/Notice";
import Careers from "../pages/MediaContact/Careers";
import VacanciesInCollege from "../pages/MediaContact/VacanciesInCollege";
import RecruitmentPortal from "../pages/MediaContact/RecruitmentPortal";
import ResultNotification from "../pages/MediaContact/ResultNotification";
import FormsGuidelines from "../pages/MediaContact/FormsGuidelines";
import ContactDirectory from "../pages/MediaContact/ContactDirectory";
import AddressMap from "../pages/MediaContact/AddressMap";
import SocialMedia from "../pages/MediaContact/SocialMedia";
import PopupEnquiries from "../pages/MediaContact/PopupEnquiries";
import StudentQueries from "../pages/MediaContact/StudentQueries";
import StudentTestimonial from "../pages/MediaContact/StudentTestimonial";

import SiteSettings from "../pages/Settings/SiteSettings";
import UserManagement from "../pages/Settings/UserManagement";
import RoleManagement from "../pages/Settings/RoleManagement";

import TermsAndConditions from "../pages/TermsAndPolicies/TermsAndConditions";

const routes = [
  { path: "cms/pages", element: <PagesList /> },
  { path: "cms/menus", element: <MenuList /> },
  { path: "cms/media-library", element: <MediaLibrary /> },

  { path: "about/history", element: <History /> },
  { path: "about/vision-mission", element: <VisionMission /> },
  { path: "about/college-at-glance", element: <CollegeAtGlance /> },
  { path: "about/college-kulgeet", element: <CollegeKulgeet /> },
  { path: "about/academic-heritage", element: <AcademicHeritage /> },
  { path: "about/governance/chairman", element: <Chairman /> },
  { path: "about/governance/vice-chairman", element: <ViceChairman /> },
  { path: "about/governance/registrar", element: <Registrar /> },
  { path: "about/governance/chief-proctor", element: <ChiefProctor /> },
  { path: "about/governance/finance-officer", element: <FinanceOfficer /> },
  { path: "about/governance/heads-of-departments", element: <HeadsOfDepartments /> },
  { path: "about/governance/dean-students-welfare", element: <DeanStudentsWelfare /> },
  { path: "about/admin-authorities/director-ranking-cell", element: <DirectorRankingCell /> },
  { path: "about/admin-authorities/admission-cell", element: <AdmissionCell /> },
  { path: "about/admin-authorities/hostel-administrators", element: <HostelAdministrators /> },
  { path: "about/admin-authorities/faculty-administrators", element: <FacultyAdministrators /> },
  { path: "about/admin-authorities/proctorial-officials", element: <ProctorialOfficials /> },
  { path: "about/committees/manage", element: <ManageCommittees /> },
  { path: "about/committees/dynamic/:id", element: <CommitteeMembers /> },
  { path: "about/committees/college-court", element: <CollegeCourt /> },
  { path: "about/committees/executive-council", element: <ExecutiveCouncil /> },
  { path: "about/committees/academic-council", element: <AcademicCouncil /> },
  { path: "about/committees/finance-committee", element: <FinanceCommittee /> },

  { path: "academics/academic-calendar", element: <AcademicCalendar /> },
  { path: "academics/ug-programmes", element: <UGProgrammes /> },
  { path: "academics/pg-programmes", element: <PGProgrammes /> },

  { path: "academics/admissions/ug", element: <UGAdmission /> },
  { path: "academics/admissions/pg", element: <PGAdmission /> },
  { path: "academics/admissions/lurns", element: <LURNS /> },
  { path: "academics/admissions/bel-ed", element: <BElEdProgramme /> },
  { path: "academics/admissions/med", element: <MEdProgramme /> },
  { path: "academics/admissions/bed", element: <BEdProgramme /> },
  { path: "academics/admissions/bped-mped", element: <BPEdMPEdProgramme /> },
  { path: "academics/department/syllabus", element: <Syllabus /> },
  { path: "academics/department/time-tables", element: <TimeTables /> },
  { path: "/academics/department/notices", element: <DepartmentNotices /> },
  { path: "/academics/institutes/ongc-centre", element: <OngcCentre /> },
  { path: "academics/department/faculty-members", element: <FacultyMembers /> },
  { path: "academics/faculty-department", element: <FacultyDepartment /> },

  { path: "examination/notice", element: <ExaminationNotice /> },
  { path: "examination/schedule", element: <ExaminationSchedule /> },
  { path: "examination/links", element: <ExaminationLinks /> },
  { path: "examination/results", element: <Results /> },

  { path: "facilities/canteens", element: <Canteens /> },
  { path: "facilities/child-care-centre", element: <ChildCareCentre /> },
  { path: "facilities/yoga", element: <Yoga /> },
  { path: "facilities/student-hostels", element: <StudentHostels /> },
  { path: "facilities/placement-cell", element: <PlacementCell /> },
  { path: "facilities/happy-thinking-laboratory", element: <HappyThinkingLaboratory /> },
  { path: "facilities/sports/outdoor-sports", element: <OutdoorSports /> },
  { path: "facilities/sports/indoor-sports", element: <IndoorSports /> },
  { path: "facilities/sports/gymnasium", element: <Gymnasium /> },

  { path: "library/ug-library", element: <UGLibrary /> },
  { path: "library/pg-library", element: <PGLibrary /> },

  { path: "media-contact/media", element: <Media /> },
  { path: "media-contact/college-in-news", element: <CollegeInNews /> },
  { path: "media-contact/photo-gallery", element: <PhotoGallery /> },
  { path: "media-contact/banners", element: <BannerManagement /> },
  { path: "media-contact/videos", element: <Videos /> },
  { path: "media-contact/press-release", element: <PressRelease /> },
  { path: "media-contact/notice", element: <Notice /> },
  { path: "media-contact/careers", element: <Careers /> },
  { path: "media-contact/vacancies-in-college", element: <VacanciesInCollege /> },
  { path: "media-contact/recruitment-portal", element: <RecruitmentPortal /> },
  { path: "media-contact/result-notification", element: <ResultNotification /> },
  { path: "media-contact/forms-guidelines", element: <FormsGuidelines /> },
  { path: "media-contact/contact/contact-directory", element: <ContactDirectory /> },
  { path: "media-contact/contact/address-map", element: <AddressMap /> },
  { path: "media-contact/contact/social-media", element: <SocialMedia /> },
  { path: "media-contact/popup-enquiries", element: <PopupEnquiries /> },
  { path: "media-contact/student-queries", element: <StudentQueries /> },
  { path: "media-contact/student-testimonial", element: <StudentTestimonial /> },

  { path: "settings/site-settings", element: <SiteSettings /> },
  { path: "settings/users", element: <UserManagement /> },
  { path: "settings/roles", element: <RoleManagement /> },

  { path: "terms-and-policies/terms-and-conditions", element: <TermsAndConditions /> },
];

export default routes;
